import React, { useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import "../../common/CustomModal.css";
import { useEffect } from "react";

const LeadForwardModal = ({ show, handleClose, item, leadId, updateSatus }) => {
  const [phone, setPhone] = useState("");
  const [showPhone, setShowPhone] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (show) {
      setPhone("");
      setShowPhone(false);
      setError(false);
    }
  }, [show]);
  const handleInputChange = (e) => {
    // Allow only numbers (0-9) in the input
    const value = e.target.value.replace(/[^0-9]/g, "");
    setPhone(value);
  };
  return (
    <Modal
      className="custom-modal1 p-10"
      size="md"
      centered
      show={show}
      onHide={handleClose}
    >
      <div class="header-pop p-3 mb-1">
        <div class="header-title">Forward Lead</div>
        <a class="close-pop" onClick={() => handleClose()}>
          ×
        </a>
      </div>
      <Modal.Body style={{ width: "100%" }}>
        <div className="forward-modal-container dis-flex">
          <div
            className="forward-icon"
            //onClick={() => setShowPhone(!showPhone)}
          >
            {/**SL-710 */}
            <a
              onClick={() => updateSatus(leadId, "FORWARDED")}
              href={`https://api.whatsapp.com/send/?text=%0A%0AProduct Name: ${encodeURIComponent(
                item?.product.productName
              )}%0AProduct Link : http://toolsvilla.com/${item?.product?.urlKey}%0ACustomer Name : ${encodeURIComponent(
                item?.name
              )}%0AMobile number   : ${item?.phone}%0AEmail   : ${
                item?.email
              }%0AAddress : ${encodeURIComponent(item?.state)}, ${
                item?.pincode
              }%0ARemarks : ${encodeURIComponent(
                item?.remark
              )}%0A----------------------------%0A${encodeURIComponent(
                "We believe this lead could be a great fit for you !"
              )}%0A${encodeURIComponent(
                "This Lead has been forwarded to you from Toolsvilla Portal."
              )}`}
              target="_blank"
            >
            <i class="fa fa-whatsapp" aria-hidden="true"></i>
            <br />
            Whatsapp
            </a>
          </div>
          <div className="forward-icon">
            <a
              onClick={() => updateSatus(leadId, "FORWARDED")}
              href={`http://mail.google.com?view=cm&fs=1&su=Latest Lead for You&body=%0AProduct Name: ${encodeURIComponent(
                item?.product.productName
              )}%0AProduct Link : http://toolsvilla.com/${item?.product?.urlKey},%0ACustomer Name : ${encodeURIComponent(
                item?.name
              )},%0AMobile number   : ${item?.phone}%0AEmail   : ${
                item?.email
              }%0ARemarks : ${encodeURIComponent(
                item?.remark
              )}%0A----------------------------%0A${encodeURIComponent(
                "We believe this lead could be a great fit for you !"
              )}%0A${encodeURIComponent(
                "This Lead has been forwarded to you from Toolsvilla Portal."
              )}`}
              target="_blank"
            >
              <i class="fa fa-envelope" aria-hidden="true"></i>
              <br />
              Email
            </a>
          </div>
        </div>
        {showPhone && (
           <>
          <div className=" relative wallet-container">
          <div className="forward-phone">
            <input
              className="add_pro_form_card_input add_pro_form_inp_select"
              type="text"
              value={phone}
              onChange={(e) => handleInputChange(e)}
              maxLength={10}
              style={{ padding: "8px 55px", fontSize: 16 }}
            />
            
            <div
              className="mobile-prefix"
              style={{ left: 0, top: "3px", fontSize: 16 }}
            >
              +91{" "}
              <span
                style={{ color: "rgb(22 91 91 / 45%)", fontSize: "21.673px" }}
              >
                |
              </span>
            </div>
            {phone && phone.length==10 ? (
              <a
              onClick={() => updateSatus(leadId, "FORWARDED")}
              href={`https://api.whatsapp.com/send/?phone=${phone}&text=%0A%0AProduct Name: ${encodeURI(
                item?.product.productName
              )}%0AProduct Link : http://toolsvilla.com/${item?.product?.urlKey}%0ACustomer Name : ${encodeURI(
                item?.name
              )}%0AMobile number   : ${item?.phone}%0AEmail   : ${
                item?.email
              }%0AAddress : ${encodeURI(item?.state)}, ${
                item?.pincode
              }%0ARemarks : ${encodeURI(
                item?.remark
              )}%0A----------------------------%0A${encodeURI(
                "We believe this lead could be a great fit for you !"
              )}%0A${encodeURI(
                "This Lead has been forwarded to you from Toolsvilla Portal."
              )}`}
              target="_blank"
            >
                <div class="add_pro_form_fin_btns ">
                  <button>Send</button>
                </div>
              </a>
            ) : (
              <div class="add_pro_form_fin_btns ">
                  <button onClick={()=>setError(true)}>Send</button>
              </div>
            )}
            </div>
         {error && (phone=="" || phone.length!=10)?<div className="validation-error">Please enter 10 digit mobile number</div>:""}
          </div>
         </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default LeadForwardModal;
